import { render, staticRenderFns } from "./CustomStepperTab.vue?vue&type=template&id=52acae45&scoped=true"
import script from "./CustomStepperTab.vue?vue&type=script&lang=js"
export * from "./CustomStepperTab.vue?vue&type=script&lang=js"
import style0 from "./CustomStepperTab.vue?vue&type=style&index=0&id=52acae45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52acae45",
  null
  
)

export default component.exports